import {cancelPrint, poll, print} from "@/http/services/http-services-print";
import {transform} from "ol/proj";
import {stopLadda} from "@/helpers/ladda-helper";
import {getPrintSettings} from "@/helpers/print/print-scales-helper";
import {getPrintLayers} from "@/helpers/print/layers/print-layer-helper";
import {getViewRotation} from "@/helpers/ol/ol-view";
import {getAllBySelector, getBySelector, isVisibleBySelector} from "@/helpers/element-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import {showNotification} from "@/helpers/notification-helper";
import {
    clearGeoJsonLayers,
    createGeoJsonLayer,
    getGeoJsonLayers,
    removeGeoJsonLayer
} from "@/helpers/ol/ol-geo-json-helper.js";
import {getFilterSelectLayerValue} from "@/helpers/filter/filter-geometry-helper.js";
import {
    getBookmarkPresentationsByID,
    getLayersIncludes,
    getLayersIncludesFeatures, removeLayersIncludes
} from "@/helpers/ol/ol-layer-helper.js";
import {getWfsStyleFunction} from "@/modules/ol/service/ol-service-wfs.js";

export function printMap(contentType = 'pdf') {

    delete window.printTemplate
    const printSettings = getPrintSettings()

    const extent = printSettings.feature.getGeometry().getExtent()

    const bottomLeft = [extent[0], extent[1]]
    const topRight = [extent[2], extent[3]]
    const projection = getViewProjectionName()

    const height = (topRight[1] - bottomLeft[1]) / 2
    const width = (topRight[0] - bottomLeft[0]) / 2
    const center = [bottomLeft[0] + width, bottomLeft[1] + height]

    const request = {}

    request.attributes = []
    getAllBySelector('.iptPrintAttributes').forEach(element => {
       request.attributes.push({
              name: element.dataset.name,
              value: element.value
       })
    })

    if(window.printLayout.attributes.find(attribute => attribute.name === 'kv_website_name')) {
        request.attributes.push({
            name: 'kv_website_name',
            value: window.websiteName
        })
    }

    request.datum = ''
    request.hideScale = !window.printLayout.attributes.find(attribute => attribute.name === 'Schaal');
    request.overviewMap = !!window.printLayout.attributes.find(attribute => attribute.name === 'overviewMap');

    request.scale = printSettings.scale

    request.layout = window.printLayout.name
    request.rotation = getViewRotation()
    request.projection = projection
    request.legenda_title = ''
    request.x = center[0]
    request.y = center[1]
    request.dpi = 150
    request.cor_path = ''

    const app = getBySelector('#slcPrintTemplate')
    if(app) {
        request.app = app.value
    }

    request.extension = contentType

    const printLayers = getPrintLayers()

    request.list_layers_json = JSON.stringify(printLayers);

    request.legends_values = []

    const chbPrintGrid = getBySelector('#chbPrintGrid')
    if(chbPrintGrid && chbPrintGrid.checked) {
        request.grid = 1
    }

    getAllBySelector('.chbSelLegend').forEach(element => {
        if(element.checked) {
            request.legends_values.push({
                name: element.dataset.displayName,
                value: element.value
            })
        }
    })

    let interval
    let ref
    print(request).then((response) => {
        return response.json()
    }).then((result) => {
        ref = result.ref

        const timeout = setTimeout(() => {
                cancelPrint(ref).then(() => {
                    clearInterval(interval)
                    stopLadda()
                    showNotification('Er is iets misgegaan bij het printen. Neem contact op met de beheerder', '', 'warning')
                })
            },
            60000
        );

        interval = setInterval(() => {
            poll(ref).then((result) => {
                if(result.done) {
                    clearInterval(interval)
                    clearTimeout(timeout);
                    const btnPrintDownloadPDF = document.getElementById('btnPrintDownloadPDF')

                    let fileName = document.getElementById('iptPrintFileName')
                    if(fileName && fileName.value) {
                        fileName = fileName.value
                    } else {
                        fileName = 'KaartViewer'
                    }

                    const url = window.kaartViewerUrl + '/admin/rest/printapi/bookmark/' + window.websiteName + '/download/' + fileName + '?contentType=' + contentType + '&ref=' + ref
                    btnPrintDownloadPDF.setAttribute('href', url)
                    btnPrintDownloadPDF.classList.remove('d-none')
                    stopLadda()
                }
            })
        }, 1500)
    })
}

export function getPrintSelectLayerValue() {
    const element = getBySelector('#slcPrintSelectLayer')

    // Only show when filter menu is visible
    if(element && isVisibleBySelector('bookmark-print')) {
        return element.value
    }
    return undefined
}

export function addPrintSelectLayerItem(items, feature = undefined) {
    const bookmarkPresentationID = getPrintSelectLayerValue()

    if(bookmarkPresentationID && items) {
        const mainTab = items.mainTabs.find(mainTab => mainTab.BookmarkPresentationID === parseInt(bookmarkPresentationID))

        if(mainTab.features.length > 0) {
            feature = mainTab.features[0].feature
        }

        const service = getBookmarkPresentationsByID(mainTab.BookmarkPresentationID)
        let styleFunction = undefined
        if(service && ['WFS','WMS'].includes(service.Type)) {
            styleFunction = getWfsStyleFunction(service, true)
        }

        createGeoJsonLayer(feature, 'print-select-layer-item-' + feature.id, true, undefined, styleFunction)

        getBySelector('#divPrintSelectLayerItems').innerHTML +=
            `<div class="card card-hover-secondary mt-2">    
                <div class="card-header bg-lighter p-1">
                    ${feature.id}
                    <button data-id="${feature.id}" title="Verwijder uit print lagen" class="btn btn-sm borderless icon-btn float-right btnRemovePrintSelectLayerItem">
                        <span class="fa fa-times" data-id="${feature.id}"></span>
                    </button>
                </div>
            </div>`

        getAllBySelector('.btnRemovePrintSelectLayerItem').forEach(element => {
            element.addEventListener('click', (e) => {
                const id = e.target.dataset.id
                e.target.closest('.card').remove()
                removeGeoJsonLayer('print-select-layer-item-' + id)
            })
        })
    }
}

export function clearPrintSelectLayerItems() {
    removeLayersIncludes('print-select-layer-item-')
}